import { createContext } from "react"

import type { GeometryPickerConfig } from "./typings"

export type GeometryPickerConfigType = (func: (close: () => void) => GeometryPickerConfig) => void

export const GeometryPickerContext = createContext<GeometryPickerConfigType>(() => {
	throw new Error("No GeometryPickerContext found")
})
